import type { ZoneType } from '../models/zone-type.enum';

export class ZoneTypeHelper {
  public static toString(zones: ZoneType[], translationFunc: (key: string) => string): string {
    switch (zones.length) {
      case 1:
        return `${translationFunc('pricecalculatorpage.one').toLowerCase()} ${translationFunc('pricecalculatorpage.zone').toLowerCase()}`;
      case 2:
        return `${translationFunc('pricecalculatorpage.two').toLowerCase()} ${translationFunc('pricecalculatorpage.zones').toLowerCase()}`;
      case 3:
        return `${translationFunc('pricecalculatorpage.three').toLowerCase()} ${translationFunc('pricecalculatorpage.zones').toLowerCase()}`;
      default:
        return '';
    }
  }
}
